export default "__VITE_ASSET__728f0b73__"